import { Environement } from "./Environement";

export class Constant {
  static formTextMinLength: number = Environement.envIsDev ? 5 : 15;
  static formTextMaxLength: number = 10000;
  static formListMinLength: number = 0;

  static CACHE_DURATION_DAYS: number = 7;
}
